import { z } from 'zod';

export const sectionSchema = z.object({
  section_name: z
    .string()
    .min(1, 'Section name is required')
    .max(50, 'Section name must be less than 50 characters'),
  description: z
    .string()
    .min(1, 'Description is required')
    .max(500, 'Description must be less than 500 characters'),
  section_order: z
    .number()
    .int('Order must be a whole number')
    .min(1, 'Order must be at least 1')
    .optional(),
});

export type SectionFormData = z.infer<typeof sectionSchema>;
